// NGRX
import {Store, select} from '@ngrx/store';
// CRUD
import {BaseDataSource, QueryResultsModel} from '../../_base/crud';
// State
import {AppState} from '../../reducers';
// Selectirs
import {selectIpmsStandardsQueryResult, selectIpmsStandardsPageLoading, selectIpmsStandardsShowInitWaitingMessage} from '../_selectors/ipms-standard.selectors';

export class IpmsStandardsDataSource extends BaseDataSource {
    trashed: number = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectIpmsStandardsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectIpmsStandardsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectIpmsStandardsQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        });

    }
}
